import React from 'react';
import { cn } from '@/helpers/classnames';

interface LinearProgressProps {
  /** 0-100. Leave undefined for an indeterminate bar. */
  value?: number;
  className?: string;
}

const LinearProgress: React.FC<LinearProgressProps> = ({
  value,
  className,
}) => (
  <div
    role="progressbar"
    aria-valuenow={value}
    aria-valuemin={value === undefined ? undefined : 0}
    aria-valuemax={value === undefined ? undefined : 100}
    className={cn('h-1 w-full overflow-hidden bg-primary-200', className)}
  >
    <div
      className={cn(
        'h-full bg-primary-500',
        value === undefined && 'w-1/3 animate-pulse',
      )}
      style={value === undefined ? undefined : { width: `${value}%` }}
    />
  </div>
);

export default LinearProgress;
